<template>
  <div>
    <k-text-field
      v-model="password"
      :label="label"
      :hint="hint"
      :min="size"
      :prepend-icon="generateIcon ? 'refresh' : ''"
      :prepend-icon-cb="generate"
      :append-icon="visible ? 'visibility_off' : 'visibility'"
      :append-icon-cb="() => (visible = !visible)"
      :type="visible ? 'text' : 'password'"
      :error="error"
      :error-messages="messages"
      autocomplete="new-password"
    ></k-text-field>

    <k-text-field
      v-model="password_confirm"
      :label="confirmLabel"
      :hint="hint"
      :min="size"
      :prepend-icon="generateIcon ? 'refresh' : ''"
      :prepend-icon-cb="generate"
      :append-icon="visible ? 'visibility_off' : 'visibility'"
      :append-icon-cb="() => (visible = !visible)"
      :type="visible ? 'text' : 'password'"
      :error-messages="messages"
      autocomplete="new-password"
    ></k-text-field>
  </div>
</template>

<script>
export default {
  props : {
    size: {
      type: String,
      default: '32'
    },
    characters: {
      type: String,
      default: 'a-z,A-Z,0-9'
    },
    placeholder: {
      type: String,
      default: 'Password'
    },
    auto: Boolean,
    value: Object,
    hint: String,
    label: String,
    confirmLabel: String,
    generateIcon: Boolean
  },
  watch: {
    password (newVal) {
      if(newVal.length < 6) {
        this.messages = ["Password too short!"];
        this.error = true;
        return;
      }
      if(newVal != this.password_confirm) {
        this.messages = ["Password don't match!"];
        this.error = true;
        return;
      }

      this.messages = [];
      this.error = false;
      this.$emit("input", {password: newVal, confirm: this.password_confirm});
    },
    password_confirm(newVal) {
      if(this.password.length < 6) {
        this.messages = ["Password too short!"];
        this.error = true;
        return;
      }
      if(newVal != this.password) {
        this.messages = ["Password don't match!"];
        this.error = true;
        return;
      }

      this.messages = [];
      this.error = false;
      this.$emit("input", {password: this.password, confirm: newVal});
    },
    'value.password'(newVal) {
      if(this.password != newVal) this.password = newVal;
    },
    'value.confirm'(newVal) {
      if(this.password_confirm != newVal) this.password_confirm = newVal;
    }
  },
  data() {
    return {
      visible: false,
      error: false,
      messages: [],
      password: "",
      password_confirm: "",
    }
  },
  mounted: function() {
    if(this.auto) {
      this.generate();
    }
  },
  methods: {
    generate: function() {
      let charactersArray = this.characters.split(',');
      let CharacterSet = '';
      let password = '';

      if( charactersArray.indexOf('a-z') >= 0) {
        CharacterSet += 'abcdefghijklmnopqrstuvwxyz';
      }
      if( charactersArray.indexOf('A-Z') >= 0) {
        CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      }
      if( charactersArray.indexOf('0-9') >= 0) {
        CharacterSet += '0123456789';
      }
      if( charactersArray.indexOf('#') >= 0) {
        CharacterSet += '![]{}()%&*$#^<>~@|';
      }

      for(let i=0; i < this.size; i++) {
        password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
      }
      this.password = password;
      this.password_confirm = password;
      this.visible = true;
    }
  }
}
</script>
